import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import CourseVideoListModule from "./course_video_list_module";


export default function CourseVideoList({name, modules, courseId, courseSlug, lessonSelected, visited, favorites}) {
    const [isActiveOnMenu, setIsActiveOnMenu] = useState(false)

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setIsActiveOnMenu(menuitem === 'video')
        }

        document.addEventListener('course_menu_tabs', listener)

        return () => {
            document.removeEventListener('course_menu_tabs', listener)
        }

    }, []);

    useEffect(() => {
        if(lessonSelected) {
            const event = new CustomEvent('course_select_video', {detail: lessonSelected});
            document.dispatchEvent(event)
        }
    }, [lessonSelected])

    if(!isActiveOnMenu) return null;

    return (
        <Container>
            {modules.map((module, ind) => {
                return <CourseVideoListModule
                    lessonSelected={lessonSelected}
                    shouldDeploy={ind === 0}
                    courseId={courseId}
                    courseSlug={courseSlug}
                    visited={visited}
                    favourite={favorites}
                    key={`course_video_list_module_${module.id}`}
                    name={module.name}
                    blocks={module.blocks}

                />
            })}
        </Container>
    )
}

const Container = styled.div`
    padding: 8px;
    padding-top: 24px;
    padding-bottom: 80px;
    height: calc(100vh - 280px);
    overflow-y: scroll;
`

const Name = styled.div`
    color: white;
    font-size: 22px;
    padding-bottom: 8px;
    text-align: center;
`

if (document.getElementsByTagName('course-tool-video-list')) {
    const elms = document.getElementsByTagName('course-tool-video-list')

    for(let elm of elms) {
        const name = elm.attributes['name'].value
        const modules = JSON.parse(elm.attributes['modules'].value)
        const courseId = elm.attributes['course-id'].value
        const courseSlug = elm.attributes['course-slug'].value
        const visited = JSON.parse(elm.attributes['visited'].value)
        const favorites = JSON.parse(elm.attributes['favorites'].value)
        const lesson = elm.attributes['lesson'] ?  JSON.parse(elm.attributes['lesson'].value) : null
        ReactDOM.render(<CourseVideoList
            lessonSelected={lesson}
            favorites={favorites}
            visited={visited}
            name={name}
            modules={modules}
            courseSlug={courseSlug}
            courseId={courseId} />, elm);
    }
}
